import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@mui/utils';
import { makeStyles } from '@mui/styles';
import { Box, Checkbox, TableRow, TableCell, TableHead, TableSortLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------

UserListHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func
};

export default function UserListHead({
  order,
  orderBy,
  rowCount,
  headLabel,
  numSelected,
  onRequestSort,
  onSelectAllClick,
  check,
  checkFunc,
  noCheckbox
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const { t } = useTranslation();

  return (
    <TableHead style={{ backgroundColor: '#f78181' }}>
      <TableRow>
        {headLabel.map((headCell, key) => (
          <TableCell
            key={headCell.id}
            style={{ textAlign: document.body.dir === 'rtl' ? 'right' : 'left' }}
            align={document.body.dir === 'rtl' ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {key === 0 && !noCheckbox && (
              <Checkbox
                onChange={checkFunc}
                checked={check}
                sx={{
                  color: 'white',
                  '&.Mui-checked': {
                    color: 'white'
                  }
                }}
              />
            )}
            <TableSortLabel
              hideSortIcon
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              style={{ color: 'white' }}
            >
              {t(headCell.label)}
              {orderBy === headCell.id ? (
                <Box sx={{ ...visuallyHidden }}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
